import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "relative w-full" }
const _hoisted_2 = { class: "border-b border-white/5 w-full h-[75px] flex items-center justify-end px-4 sm:px-14 py-6" }
const _hoisted_3 = { class: "flex items-center gap-4" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "flex items-center gap-4 text-white" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "relative"
}
const _hoisted_8 = {
  key: 0,
  class: "py-1"
}
const _hoisted_9 = { class: "flex items-center gap-2 text-md" }
const _hoisted_10 = {
  key: 1,
  class: "flex items-center justify-center p-4"
}
const _hoisted_11 = {
  key: 0,
  class: "absolute top-full right-0 transform mt-4 tooltip-container w-full min-w-[350px]"
}
const _hoisted_12 = { class: "bg-gradient-to-r from-emerald-900/80 to-emerald-700/80 backdrop-blur-sm text-white px-4 py-3 rounded-lg shadow-lg tooltip-bounce" }
const _hoisted_13 = { class: "flex items-center gap-2" }
const _hoisted_14 = {
  key: 0,
  class: "hidden sm:flex items-center gap-3"
}
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = { class: "flex items-center gap-3" }
const _hoisted_17 = { class: "relative" }
const _hoisted_18 = {
  key: 0,
  class: "h-9 w-[180px] flex items-center justify-center"
}
const _hoisted_19 = {
  key: 1,
  class: "relative"
}
const _hoisted_20 = { class: "flex items-center gap-2 z-10 relative" }
const _hoisted_21 = { class: "truncate" }
const _hoisted_22 = { class: "py-1" }
const _hoisted_23 = { class: "flex items-center gap-2 text-md" }
const _hoisted_24 = {
  key: 0,
  class: "absolute inset-0 rounded-md -z-10 glow-effect"
}

import { useBot } from '@/composables/useBot';
import { Bot } from '@/interfaces/Bot';
import { CrownIcon, BotIcon, Loader2, ActivityIcon, GitBranch, UserIcon } from 'lucide-vue-next';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { watch, ref, onMounted } from 'vue';
import { Pagination as IPagination } from '@/interfaces/Pagination';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@/components/ui/select'
import { flows, useFlow } from '@/composables/chatFlow/useFlow';
import { Flow } from '@/interfaces/chat-flow/flow/Flow';
import { FlowStatusEnum } from '@/enums/chatFlow/flows/FlowStatusEnum';
import { computed } from '@vue/reactivity';
import { BotTypeEnum } from '@/enums/bots/BotTypeEnum';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLayoutNav',
  setup(__props) {

const bots = ref<IPagination<Bot>>();
const { selectedBot, getAll, selectBot, selectableBots } = useBot();
const selectedBotId = ref<string>('');
const { getAll: getAllFlows, update } = useFlow();

// Flow state
const isLoading = ref(false);

// Sample flows data - replace with your actual data
const selectedFlow = computed(() => {
  return flows.value?.data.find(f => f.status === FlowStatusEnum.ACTIVE)?.id.toString();
});

const updateFlowStatus = async (flowId: number, status: FlowStatusEnum) => {
  await update(flowId, { status })
  
  if (flows.value) {
    flows.value.data = flows.value.data.map(flow => {
      if (flow.id === flowId) {
        return { ...flow, status };
      } else {
        return { ...flow, status: FlowStatusEnum.INACTIVE };
      }
    });
  }
}

watch(selectedBot, (newBot) => {
  selectedBotId.value = String(newBot?.id ?? '');
});

// Load bots when component mounts
const loadBots = async () => {
  bots.value = await getAll({ perPage: '50' });
  selectableBots.value = bots.value.data;
};

// Watch for selectedBotId changes to update the selected bot
watch(selectedBotId, async (newId) => {
  if (newId && bots.value) {
    const bot = bots.value.data.find(b => String(b.id) === newId);
    if (bot) {
      selectBot(bot);
    }
  }
});

onMounted(() => {
  // Load flows when component mounts
  getAllFlows({ perPage: '50' }).then(fetchedFlows => {
    flows.value = fetchedFlows;
  });
});
// Initialize bots data
loadBots();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Select), {
            modelValue: selectedBotId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedBotId).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(SelectTrigger), { class: "w-auto bg-white/5 border-white/10 relative min-w-[200px]" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    (_unref(selectedBot))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_unref(CrownIcon), { class: "h-5 w-5 text-yellow-500" })
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_unref(CrownIcon), { class: "h-5 w-5 text-emerald-400 relative z-10 animate-pulse-subtle" }),
                          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute inset-0 z-0" }, [
                            _createElementVNode("div", { class: "wave-effect wave-1" }),
                            _createElementVNode("div", { class: "wave-effect wave-2" }),
                            _createElementVNode("div", { class: "wave-effect wave-3" })
                          ], -1))
                        ])),
                    _createElementVNode("span", {
                      class: _normalizeClass(!_unref(selectedBot) ? 'text-emerald-400 animate-pulse-text' : 'text-white')
                    }, _toDisplayString(_unref(selectedBot) ? _unref(selectedBot).name : 'Selecionar bot'), 3)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(SelectContent), { class: "bg-[#2a2a2a] border-white/10" }, {
                default: _withCtx(() => [
                  (bots.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectableBots), (bot) => {
                          return (_openBlock(), _createBlock(_unref(SelectItem), {
                            key: bot.id,
                            value: String(bot.id),
                            class: "text-white hover:bg-white/5"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_9, _toDisplayString(bot.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_unref(Loader2), { class: "w-5 h-5 animate-spin" })
                      ]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (!_unref(selectedBot) && (bots.value?.data?.length ?? 0) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute -top-2 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-[8px] border-r-[8px] border-b-[8px] border-transparent border-b-emerald-800/80" }, null, -1)),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_unref(BotIcon), { class: "h-5 w-5 text-emerald-300" }),
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "font-medium" }, "Selecione um bot para continuar", -1))
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-xs text-emerald-200 mt-1 pl-7" }, "Escolha entre os bots disponíveis para iniciar", -1))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref(selectedBot)?.type === _unref(BotTypeEnum).CHAT_FLOW)
          ? (_openBlock(), _createBlock(_Transition, {
              key: 0,
              "enter-active-class": "transition duration-300 ease-out",
              "enter-from-class": "transform -translate-x-4 opacity-0",
              "enter-to-class": "transform translate-x-0 opacity-100",
              "leave-active-class": "transition duration-200 ease-in",
              "leave-from-class": "transform translate-x-0 opacity-100",
              "leave-to-class": "transform -translate-x-4 opacity-0"
            }, {
              default: _withCtx(() => [
                (_unref(selectedBot))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "h-8 w-[1px] bg-white/10" }, null, -1)),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            (!_unref(flows))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createVNode(_unref(Loader2), { class: "h-4 w-4 text-emerald-400 animate-spin" })
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createVNode(_unref(Select), {
                                    "model-value": _unref(selectedFlow),
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = (flowId) => updateFlowStatus(Number(flowId), _unref(FlowStatusEnum).ACTIVE)),
                                    disabled: isLoading.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(SelectTrigger), { class: "w-auto bg-white/5 border-white/10 relative min-w-[200px]" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_20, [
                                            _createVNode(_unref(GitBranch), { class: "h-4 w-4 text-emerald-300" }),
                                            _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(selectedFlow) ? _unref(flows).data.find(f => String(f.id) === _unref(selectedFlow))?.name : 'Selecionar fluxo'), 1)
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(SelectContent), { class: "bg-[#2a2a2a] border-white/10 max-h-[280px]" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_22, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flows).data, (flow) => {
                                              return (_openBlock(), _createBlock(_unref(SelectItem), {
                                                key: flow.id,
                                                value: String(flow.id),
                                                class: "text-white group"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_23, [
                                                    _createElementVNode("span", null, _toDisplayString(flow.name), 1)
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1032, ["value"]))
                                            }), 128))
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["model-value", "disabled"]),
                                  (_unref(selectedFlow) && !isLoading.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24))
                                    : _createCommentVNode("", true)
                                ]))
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_unref(Tooltip), null, {
        default: _withCtx(() => [
          _createVNode(_unref(TooltipTrigger), { asChild: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_RouterLink, {
                to: { name: 'profile' },
                class: "flex items-center justify-center w-10 h-10 rounded-full bg-white/5 hover:bg-emerald-500/20 border border-white/10 hover:border-emerald-500/30 transition-all duration-200 flex-shrink-0 ml-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(UserIcon), { class: "h-5 w-5 text-zinc-400 group-hover:text-emerald-400" })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(TooltipContent), null, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("p", null, "Meu Perfil", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})